var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOvieRectangle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 264,
    height: 86,
    viewBox: "0 0 264 86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3f3f3f",
    stopOpacity: 0.412
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_68",
    x: 0,
    y: 0,
    width: 264,
    height: 86,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Rectangle_68)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_68-2",
    "data-name": "Rectangle 68",
    width: 246,
    height: 68,
    rx: 18,
    transform: "translate(9 6)",
    opacity: 0.8,
    fill: "url(#linear-gradient)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_229",
    "data-name": "Group 229",
    transform: "translate(2418 -14305)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ovie",
    transform: "translate(-2388 14320.921)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M7.309,15.636h-2A4.981,4.981,0,0,1,3.248,15.2,5.468,5.468,0,0,1,.433,12.387,4.981,4.981,0,0,1,0,10.33v-2A4.981,4.981,0,0,1,.433,6.248,5.327,5.327,0,0,1,1.581,4.6,5.327,5.327,0,0,1,3.248,3.455,4.981,4.981,0,0,1,5.306,3h2a4.981,4.981,0,0,1,2.057.433,5.468,5.468,0,0,1,2.815,2.815,4.981,4.981,0,0,1,.433,2.057V10.33a4.981,4.981,0,0,1-.433,2.057,5.674,5.674,0,0,1-1.137,1.678,5.468,5.468,0,0,1-1.678,1.083,4.981,4.981,0,0,1-2.057.487Zm-2-10.286a2.815,2.815,0,0,0-1.083.227,3.324,3.324,0,0,0-.974.671,3.248,3.248,0,0,0-.66.964A2.761,2.761,0,0,0,2.35,8.36V10.33a2.815,2.815,0,0,0,.227,1.083A3.081,3.081,0,0,0,4.2,13.037a2.631,2.631,0,0,0,1.083.238H7.309a2.891,2.891,0,0,0,1.148-.227,3.248,3.248,0,0,0,.953-.65,3.043,3.043,0,0,0,.65-.953,2.891,2.891,0,0,0,.227-1.115v-2a2.707,2.707,0,0,0-.238-1.083,3.313,3.313,0,0,0-.66-1,3.151,3.151,0,0,0-.964-.65,2.815,2.815,0,0,0-1.083-.227Z",
    transform: "translate(0 0.25)",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M19.966,15.636a2.794,2.794,0,0,1-1.646-.5,2.869,2.869,0,0,1-1.018-1.31l-3.855-9.2a1.083,1.083,0,0,1-.108-.5,1.083,1.083,0,0,1,.325-.79,1.169,1.169,0,0,1,1.808.249l3.92,9.4a.585.585,0,0,0,.238.292.6.6,0,0,0,.368.1.617.617,0,0,0,.617-.422l3.855-9.268A1.018,1.018,0,0,1,25.445,3a1.1,1.1,0,0,1,1.039,1.581L22.63,13.828a2.837,2.837,0,0,1-2.664,1.8Zm6-11.293h0a.455.455,0,0,0,0-.108Z",
    transform: "translate(1.104 0.25)",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M28.868,15.884a1.083,1.083,0,0,1-1.18-1.148V4.58a1.166,1.166,0,1,1,2.328,0V14.736a1.083,1.083,0,0,1-1.148,1.148Zm0-13.329A1.256,1.256,0,0,1,27.59,1.267a1.256,1.256,0,0,1,.368-.91,1.332,1.332,0,0,1,1.819,0,1.278,1.278,0,0,1,.368.91,1.3,1.3,0,0,1-.368.92A1.256,1.256,0,0,1,28.868,2.555Z",
    transform: "translate(2.283 0.002)",
    fill: "#939393"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M44.147,15.632H37.986a4.9,4.9,0,0,1-2.166-.466,5.609,5.609,0,0,1-1.667-1.2,5.511,5.511,0,0,1-1.083-1.754,5.7,5.7,0,0,1-.4-2.09v-1.8a4.992,4.992,0,0,1,.444-2.079,5.468,5.468,0,0,1,1.137-1.678,5.674,5.674,0,0,1,1.678-1.083,4.937,4.937,0,0,1,2.057-.433h1.992a4.9,4.9,0,0,1,2.057.433,5.544,5.544,0,0,1,2.826,2.761A5.154,5.154,0,0,1,45.295,8.3v1.841a1.44,1.44,0,0,1-.422,1.083,1.386,1.386,0,0,1-1.018.433H35.3a2.9,2.9,0,0,0,1.083,1.224,2.956,2.956,0,0,0,1.624.476h6.161a1.169,1.169,0,0,1,0,2.328ZM35,9.276h7.969V8.323a2.761,2.761,0,0,0-.195-1.148,3.01,3.01,0,0,0-.682-.931,3.151,3.151,0,0,0-.964-.65,2.891,2.891,0,0,0-1.148-.227H37.986a2.826,2.826,0,0,0-1.083.227,3.248,3.248,0,0,0-.953.65,3.465,3.465,0,0,0-.671.974A2.794,2.794,0,0,0,35.041,8.3Z",
    transform: "translate(2.704 0.254)",
    fill: "#939393"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOvieRectangle);
export default __webpack_public_path__ + "static/media/ovie-rectangle.7fecd81bdb6b7040c8f280eb8e1d9615.svg";
export { ForwardRef as ReactComponent };